import { createAppWrap } from '../../../create_app_wrap';
import commonMixin from '../../../mixins/_common.js';

const view = '[data-view="register"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                code: '',
            };
        },
        mixins: [
            commonMixin,
        ],
        mounted: function () {
            // ogaria-userクラスがあったらsubmitする
            if ($(this.$refs.main).hasClass('ogaria-user')) {
                this.$_loading();
                $(this.$refs.form).submit();
            }
            // URLからキャンペーンコードを抽出してフォームに入れる
            const params = new URLSearchParams(window.location.search);
            this.code = params.get('code');

            // Google reCAPTCHA v3対応
            const vueThis = this;
            document.getElementById('submit_register').addEventListener('click', e => {
                e.preventDefault();
                // フォームのバリデチェック
                const form = document.getElementById('form_register');
                if (form.checkValidity() === false) {
                    if (form.reportValidity) form.reportValidity();
                    return;
                }
                vueThis.$_loading();
                // reCAPTCHA情報を載せてフォーム送信
                grecaptcha.ready(() => {
                    const siteKey = process.env.MIX_NOCAPTCHA_SITEKEY;
                    grecaptcha.execute(siteKey,  { action: 'Submit' }).then(token => {
                        document.getElementById('g-recaptcha-response').value = token;
                        form.submit();
                    });
                });
            }, false);
        },
    });
};

if (document.querySelector(view)) {
    init();
}
